import React from "react";
import styles from "./IconButton.module.scss";
import "./IconButton.scss";

/**
 * Simple button with icon
 * @param {{
 * icon:import("react").ReactNode,
 * onClick?: React.MouseEventHandler<HTMLButtonElement>,
 * type?:"button" | "submit" | "reset",
 * outlined?:boolean,
 * inverted?:boolean,
 * disabled?:boolean,
 * rounded?:boolean
 * className?:string
 * }} props - Props for the IconButton
 * @returns {JSX.Element} The rendered button.
 */
function IconButton({
  icon,
  onClick = undefined,
  type = "button",
  outlined = false,
  inverted = false,
  disabled = false,
  rounded = false,
  className = "",
}) {
  const cls =
    styles[
      `btn${inverted ? "Invert" : "Primary"}${
        outlined ? "Outlined" : "Filled"
      }${disabled ? "Disabled" : ""}`
    ];
  return (
    <button
      className={`icon-button ${cls} ${rounded ? "rounded" : ""} ${className}`}
      type={type}
      onClick={onClick}
      disabled={disabled}
    >
      {icon && icon}
    </button>
  );
}

export default IconButton;
